import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { IoArrowForward } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HiClock } from 'react-icons/hi';
import LocationImage from "../../images/Assets/locaTion2.jpg";

// ================= Address Item =================
const AddressItem = ({ country, governorate, city, externalLink }) => (
  <div className="flex flex-col md:flex-row items-center justify-between w-[90%] md:w-[75%] mx-auto p-6 rounded-2xl shadow-lg border border-secondColor bg-white/90 backdrop-blur transition-all hover:shadow-2xl">

    <div className="flex items-center gap-3 text-primeColor-500 font-bold text-lg">
      <FaMapMarkerAlt className="text-2xl" />
      {country}
    </div>

    <div className="text-gray-700 font-semibold text-lg">
      {governorate}
    </div>

    <a
      href={externalLink}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 px-6 py-3 bg-primeColor-500 text-white rounded-xl font-bold hover:bg-primeColor-600 transition"
    >
      {city}
      <IoArrowForward className="text-2xl" />
    </a>
  </div>
);

// ================= Schedule Card =================
// const ScheduleCard = () => {
//   const { t, i18n } = useTranslation();
//   const isRTL = i18n.language === 'ar';

//   const schedule = [
//     // {
//     //   day: t('location.schedule.monday'),
//     //   times: [t('location.schedule.mondayTime')],
//     // },
//     {
//       day: t('location.schedule.daily'),
//       times: [t('location.schedule.dailyTime')],
//     },
//     {
//       day: t('location.schedule.friday'),
//       times: [t('location.schedule.fridayTime')],
//     },
//   ];

//   return (
//     <div className="w-[90%] md:w-[60%] mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border" dir={isRTL ? 'rtl' : 'ltr'}>

//       <div className="bg-primeColor-500 p-6 text-white flex items-center justify-between">
//         <div>
//           <h2 className="text-2xl font-bold flex items-center gap-2">
//             <HiClock />
//             {t('location.scheduleTitle')}
//           </h2>
//           <p className="text-sm opacity-90">
//             {t('location.description')}
//           </p>
//         </div>
//         <HiClock className="w-12 h-12 opacity-20" />
//       </div>

//       <div className="p-4 space-y-2" dir={isRTL ? 'rtl' : 'ltr'}>
//         {!isRTL&&schedule.map((item, index) => (
//           <div
//             key={index}
//             className={`flex ${isRTL ? 'flex-row-reverse text-right' : 'flex-row text-left'} justify-between items-center p-3 rounded-lg bg-gray-50` } dir={isRTL ? 'rtl' : 'ltr'}
//           >
//             <span className="font-bold text-gray-700">
//               {item.day}
//             </span>
//             <div className="text-sm text-gray-600">
//               {item.times.map((t, i) => (
//                 <div key={i}>{t}</div>
//               ))}
//             </div>
//           </div>
//         ))}
//         {isRTL&&schedule.map((item, index) => (
//           <div
//             key={index}
//             className={`flex ${isRTL ? 'flex-row-reverse text-right' : 'flex-row text-left'} justify-between items-center p-3 rounded-lg bg-gray-50` } dir={isRTL ? 'rtl' : 'ltr'}
//           >
//             <div className="text-sm text-gray-600">
//               {item.times.map((t, i) => (
//                 <div key={i}>{t}</div>
//               ))}
//             </div>

//             <span className="font-bold text-gray-700">
//               {item.day}
//             </span>

//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// const ScheduleCard = () => {
//   const { t, i18n } = useTranslation();
//   const isRTL = i18n.language === 'ar';

//   const days = t('location.schedule.days', { returnObjects: true });

//   const schedule = [
//     ...days.map((day) => ({
//       day,
//       times: [t('location.schedule.dailyTime')],
//     })),
//     {
//       day: t('location.schedule.friday'),
//       times: [t('location.schedule.fridayTime')],
//     },
//   ];

//   return (
//     <div
//       className="w-[90%] md:w-[60%] mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border"
//       dir={isRTL ? 'rtl' : 'ltr'}
//     >
//       <div className="bg-primeColor-500 p-6 text-white flex items-center justify-between">
//         <div>
//           <h2 className="text-2xl font-bold flex items-center gap-2">
//             <HiClock />
//             {t('location.scheduleTitle')}
//           </h2>
//           <p className="text-sm opacity-90">
//             {t('location.description')}
//           </p>
//         </div>
//         <HiClock className="w-12 h-12 opacity-20" />
//       </div>

//       <div className="p-4 space-y-2">
//         {schedule.map((item, index) => (
//           <div
//             key={index}
//             className={`flex ${
//               isRTL ? 'flex-row-reverse text-right' : 'flex-row text-left'
//             } justify-between items-center p-3 rounded-lg bg-gray-50`}
//           >
//             <span className="font-bold text-gray-700">
//               {item.day}
//             </span>

//             <div className="text-sm text-gray-600">
//               {item.times.map((time, i) => (
//                 <div key={i}>{time}</div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

const ScheduleCard = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const days = t('location.schedule.days', { returnObjects: true });

  const schedule = [
    ...days.map((day) => ({
      day,
      sessions: [
        {
          label: t('location.schedule.morning'),
          time: t('location.schedule.morningTime'),
        },
        {
          label: t('location.schedule.evening'),
          time: t('location.schedule.eveningTime'),
        },
      ],
    })),
    {
      day: t('location.schedule.friday'),
      off: true,
    },
  ];

  return (
    <div
      className="w-[90%] md:w-[60%] mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="bg-primeColor-500 p-6 text-white flex items-center justify-between">
        <h2 className="text-2xl font-bold flex items-center gap-2">
          <HiClock />
          {t('location.scheduleTitle')}
        </h2>
        <HiClock className="w-12 h-12 opacity-20" />
      </div>

      <div className="p-4 space-y-3">
        {schedule.map((item, index) => (
          <div
            key={index}
            className={`p-3 rounded-lg bg-gray-50 ${
              isRTL ? 'text-right' : 'text-left'
            }`}
          >
            <div className="font-bold text-gray-700 mb-2">
              {item.day}
            </div>

            {item.off ? (
              <div className="text-red-500 font-semibold">
                {t('location.schedule.fridayTime')}
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {item.sessions.map((session, i) => (
                  <div
                    key={i}
                    className="border rounded-lg p-2 bg-white"
                  >
                    <div className="text-sm font-semibold text-primeColor-500">
                      {session.label}
                    </div>
                    <div className="text-sm text-gray-600">
                      {session.time}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// const ScheduleCard = () => {
//   const { t, i18n } = useTranslation();
//   const isRTL = i18n.language === "ar";

//   const days = t("location.schedule.days", { returnObjects: true });

//   const schedule = [
//     ...days.map((day) => ({
//       day,
//       sessions: [
//         {
//           label: t("location.BeforeIftar"),
//           time: isRTL ? "11صباحا الي 1 مساءا " : "11:00 AM to 1 PM",
//         },
//         {
//           label: t("location.AfterIftar"),
//           time: isRTL ? "8 مساءا الي 12 صباحا" : "8:00 PM to 12:00 AM",
//         },
//       ],
//     })),
//     {
//       day: t("location.schedule.friday"),
//       off: true,
//     },
//   ];

//   return (
//     <div
//       className="w-[90%] md:w-[60%] mx-auto bg-gradient-to-br from-purple-50 to-yellow-50 rounded-2xl shadow-2xl overflow-hidden border border-yellow-200"
//       dir={isRTL ? "rtl" : "ltr"}
//     >
//       {/* Header */}
//       <div className="bg-gradient-to-r from-purple-600 to-yellow-500 p-6 text-white flex items-center justify-between">
//         <h2 className="text-2xl font-bold flex items-center gap-3">
//           <HiClock className="text-yellow-200" />
//           {t("location.scheduleTitle")}
//         </h2>

//         <HiClock className="w-12 h-12 opacity-30" />
//       </div>

//       {/* Schedule */}
//       <div className="p-5 space-y-4">
//         {schedule.map((item, index) => (
//           <div
//             key={index}
//             className={`p-4 rounded-xl bg-white shadow-sm hover:shadow-md transition ${isRTL ? "text-right" : "text-left"
//               }`}
//           >
//             <div className="font-bold text-gray-800 mb-3 text-lg">
//               {item.day}
//             </div>

//             {item.off ? (
//               <div className="text-red-500 font-semibold bg-red-50 p-2 rounded-lg">
//                 {t("location.schedule.fridayTime")}
//               </div>
//             ) : (
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                 {item.sessions.map((session, i) => (
//                   <div key={i}>
//                     <div className="border border-yellow-200 rounded-xl p-3 bg-yellow-50">
//                       <div className="text-sm font-semibold text-purple-700">
//                         {session.label}
//                       </div>

//                       <div className="text-sm text-gray-700">
//                         {session.time}
//                       </div>
//                     </div>

//                     {/* Divider بين المواعيد */}
//                     {i === 0 && (
//                       <div className="flex items-center gap-2 my-2">
//                         <div className="flex-1 h-[1px] bg-gray-200"></div>
//                         <span className="text-xs text-gray-400">|</span>
//                         <div className="flex-1 h-[1px] bg-gray-200"></div>
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };


// ================= Main Page =================

const Location = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div dir={isRTL ? 'rtl' : 'ltr'} className="min-h-screen bg-backgroundColor">

      {/* ===== Header ===== */}
      <header
        className="relative h-[220px] flex items-center justify-center text-white"
        style={{
          backgroundImage: `url(https://res.cloudinary.com/dgcfs0gyw/image/upload/v1767476914/AF1QipO4EV9Fc-THt0xM08gYcL2w_tEiB1k6kX6P5TZv_s1360-w1360-h1020-rw_bkzzk6.webp)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/60 to-black/90"></div>

        <div className="relative z-10 text-center px-6">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">
            {t('location.title')}
          </h1>
          <span className="block w-32 h-1 bg-secondColor mx-auto mb-4 rounded-full"></span>
          <p className="text-lg opacity-90 max-w-xl mx-auto">
            {t('location.description')}
          </p>
        </div>
      </header>

      {/* ===== Address ===== */}
      <section className="py-14 text-center">
        <h2 className="text-2xl font-bold text-primeColor-500 mb-8">
          {t('location.addressTitle')}
        </h2>

        <AddressItem
          country={t('location.country')}
          governorate={t('location.governorate')}
          city={t('location.city')}
          externalLink="https://maps.app.goo.gl/Jetzk67KLinc291M7"
        />
      </section>

      {/* ===== Schedule ===== */}
      <section className="py-12">
        <ScheduleCard />
      </section>

      {/* ===== CTA ===== */}
      <div className="text-center py-16">
        <Link
          to="/package"
          className="px-8 py-4 bg-primeColor-500 text-backgroundColor font-bold rounded-xl text-lg hover:bg-primeColor-600 hover:text-white no-underline transition"
        >
          {t('location.viewPackages')}
        </Link>
      </div>
    </div>
  );
};

export default Location;
